import { useContext, useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import "./Booking_Details.css";

import Your_Booking_Conditions from "./your-booking-conditions/Your_Booking_Conditions";
import Your_Price_Summary from "./your-price-summary/Your_Price_Summary";
import Your_Pickup_Information from "./your-pickup-information/Your_Pickup_Information";
import Your_booking_Details from "./your-booking-details/Your_booking_Details";
import Your_Details from "./your-details/Your_Details";
import Review_Booking from "./review-booking/Review_Booking";
import { useNavigate, useParams } from "react-router-dom";
import { decodeId } from "../../../../utils/common";
import { Context } from "../../../../utils/context";

const Booking_Details = () => {
  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);

  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("details");
  const [isReviewMode, setIsReviewMode] = useState(false);
  const [ApiError, setApiError] = useState("");


  const { id } = useParams();


  const getBooking = async () => {

    const booking = await getData(`/without-login/booking/step-progress/${decodeId(id)}`);
    if (booking?.success) {
      await setBookingData(booking?.data);
      setApiError("")
    } else {
      navigate("/")
      setApiError(booking?.errors)
    }


  }
  useEffect(() => {
    getBooking()
  }, [id])
  const tabs = [
    {
      id: "details",
      label: "Your Booking Details",
      component: <Your_booking_Details setActiveTab={setActiveTab} BookingData={BookingData} getBooking={getBooking} />,
    },
    {
      id: "conditions",
      label: "Your Booking Conditions",
      component: <Your_Booking_Conditions setActiveTab={setActiveTab} BookingData={BookingData} getBooking={getBooking} />,
    },
    {
      id: "price",
      label: "Your Price Summary",
      component: <Your_Price_Summary setActiveTab={setActiveTab} />,
    },
    {
      id: "pickup",
      label: "Your Pick-up Information",
      component: <Your_Pickup_Information setActiveTab={setActiveTab} />,
    },
    {
      id: "yourdetails",
      label: "Your Details",
      component: (
        <Your_Details
          setActiveTab={setActiveTab}
          setIsReviewMode={setIsReviewMode}
        />
      ),
    },
  ];

  return (
    <section className="Booking_Details About_Banner tour_details_tabs">
      <div className="container-fluid">
        {/* Title */}
        <div className="About_Banner_holder">
          <h5 className="about_us">
            {isReviewMode ? "Review Booking" : "Booking Details"}
          </h5>
        </div>

        {/* Review Mode */}
        {isReviewMode ? (
          <Review_Booking getBooking={getBooking} />
        ) : (
          <div className="tab_content_holder">
            <Tab.Container
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              {/* Horizontal swipe tabs */}
              <div className="tabs_scroll_container">
                <Nav className="tabs_wrapper">
                  {tabs.map((tab) => (
                    <Nav.Item key={tab.id} className="tabs_item">
                      <Nav.Link
                        eventKey={tab.id}
                        className="tab_btn"
                        onClick={(e) => {
                          setActiveTab(tab.id);

                          // auto scroll active tab into view
                          e.target.scrollIntoView({
                            behavior: "smooth",
                            inline: "center",
                            block: "nearest",
                          });
                        }}
                      >
                        {tab.label}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </div>

              {/* Tab Content */}
              <Tab.Content>
                {tabs.map((tab) => (
                  <Tab.Pane key={tab.id} eventKey={tab.id}>
                    {tab.component}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div>
        )}
      </div>
    </section>
  );
};

export default Booking_Details;
